import { apiRequest, errorMessage } from '@/api/http';
import { useToast } from '@/composables/useToast';

// Opens a PDF from an endpoint that needs the login token, in a new tab. A
// bare link can't carry the token, so the PDF is fetched first and shown
// from a blob URL.
export function useOpenPdf() {
  const toast = useToast();

  return async function openPdf(path, failure = 'Could not create the report.') {
    // Open the tab now, while the click still counts as a user action, so
    // the browser doesn't block it once the PDF arrives.
    const tab = window.open('', '_blank');
    if (tab) tab.opener = null;
    try {
      const pdf = await apiRequest('get', path, undefined, { responseType: 'blob' });
      const url = URL.createObjectURL(pdf);
      if (tab) tab.location.href = url;
      else window.location.assign(url);
      setTimeout(() => URL.revokeObjectURL(url), 60_000);
    } catch (e) {
      tab?.close();
      // A failed blob request carries its JSON error as a Blob too.
      const body = e?.response?.data;
      if (body instanceof Blob) {
        try {
          e.response.data = JSON.parse(await body.text());
        } catch {
          // not JSON; fall back to the generic message
        }
      }
      toast.error(errorMessage(e, failure));
    }
  };
}
